import ModalsPopup from "@components/Modals/ModalsPopup";
import { StyledButton } from "@components/Styled/Button";
import { ComponentProps } from "@ts/components";
import React, { useState } from "react";
import tw from "twin.macro";
import ReviewsForm from "./ReviewsForm";
import { Button as ButtonUi } from "@bared/ui";

type ReviewsAddNewReviewProps = Omit<ComponentProps, "name"> & {
  className?: string;
  gender: "Mens" | "Womens";
  sku: string;
  noReview?: boolean;
};

const Button = tw(StyledButton)`
  w-full mr-0 md:max-w-[330px] md:mr-mini
`;
const Form = tw(ReviewsForm)`
  py-mega mx-auto max-w-[720px] md:px-mega
`;

const ReviewsAddNewReview = ({
  className,
  gender,
  sku,
  noReview,
}: ReviewsAddNewReviewProps) => {
  const [active, setActive] = useState(false);

  return (
    <>
      {process.env["GATSBY_FEATURE_REVIEWS_ENHANCEMENT"] ? (
        <>
          <ButtonUi
            className={className}
            size="large"
            variant={noReview ? "primary" : "secondary"}
            onClick={() => setActive(true)}
          >
            Write a Review
          </ButtonUi>

          <ModalsPopup active={active} setActive={setActive} layout="review">
            <Form sku={sku} gender={gender} />
          </ModalsPopup>
        </>
      ) : (
        <div className={className}>
          <Button
            height="56"
            textSize="16"
            colour="primary"
            onClick={() => setActive(true)}
          >
            Write a review
          </Button>

          <ModalsPopup active={active} setActive={setActive} layout="review">
            <Form sku={sku} gender={gender} />
          </ModalsPopup>
        </div>
      )}
    </>
  );
};

export default ReviewsAddNewReview;
